"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("./type");
function storeAuthenticatedUserAction(user) {
    return {
        type: type_1.STORED_AUTH_USER,
        payload: user,
    };
}
exports.storeAuthenticatedUserAction = storeAuthenticatedUserAction;
//# sourceMappingURL=action.js.map